import { useState } from 'react';
import { termsHtml } from '../../../constants/terms/terms-html';
import './terms-dialog.scss';
import { Checkbox } from '../../ui/input/checkbox';

type Props = {
  onAgree: () => void;
};

export const TermsDialogBody = ({ onAgree }: Props) => {
  const [checked, setChecked] = useState(false);

  return (
    <div>
      <div className="terms-dialog__content">
        {termsHtml}
      </div>
      <div className="terms-dialog__footer">
        <div className="terms-dialog__checkbox">
          <Checkbox
            label="利用規約に同意します"
            checked={checked}
            onClick={() => setChecked(!checked)}
          />
        </div>
        <button
          type="button"
          className="terms-dialog__button terms-dialog__button--agree"
          onClick={onAgree}
          disabled={!checked}
        >
          利用開始
        </button>
      </div>
    </div>
  );
};